import { ServiceIcon, ServiceIcons, Text } from "@zapier/design-system";
import styles from "./ZapBreakdown.module.css";
import { ZapBreakdownSkeleton } from "./ZapBreakdownSkeleton";
import { ZapBreakdownDetails } from "src/types";

export const ZapBreakdown = ({
  title,
  firstStep,
  lastStep,
  totalStepCount,
  services,
  servicesList,
}: ZapBreakdownDetails) => {
  if (!firstStep || !lastStep || !services) return <ZapBreakdownSkeleton />;

  const hasHiddenSteps = totalStepCount > 2;
  const hiddenStepLabel = totalStepCount === 3 ? "step" : "steps";

  return (
    <div className={styles.zapBreakdownWrapper} data-testid="zap-breakdown">
      <div className={styles.zapBreakdownContainer}>
        <div className={styles.title}>
          <div className={styles.servicesArea}>
            <ServiceIcons
              aria-label={`Zap uses ${servicesList.join(", ")}`}
              maxServices={3}
              services={services}
              size="medium"
              hasBorder
            />
          </div>
          <Text type="SmallPrint4Multiline">{title}</Text>
        </div>

        <div className={styles.detailsLabel}>
          <Text type="Body4">Zap details:</Text>
        </div>

        <div
          className={
            hasHiddenSteps ? styles.threeOrMoreSteps : styles.twoStepsTop
          }
        >
          <div className={styles.stepServiceIcon}>
            <ServiceIcon
              serviceName={firstStep.serviceName}
              size="small"
              src={firstStep.serviceIcon}
            />
          </div>
          <Text
            className={styles.stepLabel}
          >{`Step 1: ${firstStep.stepLabel} (${firstStep.serviceName})`}</Text>
        </div>

        {hasHiddenSteps && (
          <div className={styles.hiddenStepsContainer}>
            <hr />
            <div className={styles.hiddenSteps}>
              <Text type="SmallPrint2">
                + {totalStepCount - 2} {hiddenStepLabel}
              </Text>
            </div>
            <hr />
          </div>
        )}

        <div
          className={
            hasHiddenSteps ? styles.threeOrMoreSteps : styles.twoStepsBottom
          }
        >
          <div className={styles.stepServiceIcon}>
            <ServiceIcon
              serviceName={lastStep.serviceName}
              size="small"
              src={lastStep.serviceIcon}
            />
          </div>
          <Text
            className={styles.stepLabel}
          >{`Step ${totalStepCount}: ${lastStep.stepLabel} (${lastStep.serviceName})`}</Text>
        </div>
      </div>
    </div>
  );
};
